module.exports = __webpack_public_path__ + "media/mypage/images/icons/icon_history_-75d87dac06fa930eab3af4968dc0f55b.png";